/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:51
 * @LastEditTime: 2024-06-25 15:52:52
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/api/member.js
 */
import { get, post, put, deletes } from "@common/http";

// 获取会员列表（分页）
export const GetMemberBase = (param) => get("/member-base", param);

// 获取门店员工
export const getEmployeeAll = () => get("/employee/list");

// 获取跟进记录列表
export const getMemberTracklist = (param) => get(`/member-base/getMemberTracklist?startTime=${param.startTime}&endTime=${param.endTime}&pageNum=${param.pageNum}&pageSize=${param.pageSize}&employeeId=${param.employeeId}&memberId=${param.memberId}`);

// 新增会员
export const AddMemberBase = (param) => post("/member-base", param);

// 修改会员信息
export const PutMemberBase = (param) => put("/member-base", param);
// 修改会员备注
export const PostMemberBaseRemark = (param) => post("/member-base/update_card", param);

// 获取会员详情数据
export const GetMemberBaseDetails = (id) => get(`/member-base/${id}`);

// 查找TMemberBase
export const getMemberInfo = (param) => get(`/member-base/info`, param);

// 会员导入

// 充值卡导入
export const importRechargeCard = (param, config) => post(`/member-base/import-recharge-card/`, param, config);

// 次卡导入
export const importTimeCard = (param) => post(`/member-base/import-time-card`, param, cb);

// 导入日志
export const getMemberImport = (param) => get(`/member-import`, param);

// 获取开卡记录统计数据
export const GetMemberOpenCard = (param) => get("/member-base/open-card-statistics", param);

// 获取开卡记录列表 /member-base/get-card-by-phone
// export const GetMemberOpenCardList = param =>
//     get("/member-base/get-card-by-phone", param);

export const GetMemberOpenCardList = (param) => get("/member-base/get-memberCard-by-phone", param);

// 修改会员备注
export const putRemark = (param) => post("/member-base/update_base", param);

// 根据会员id获取交易记录列表
export const GetMemberOrderList = (param) => get("/order", param);

// 根据会员id获取会员相册列表
export const GetMemberAlbumList = (param) => get("/member-album/list", param);

// 获取会员中心
export const GetMemberList = (param) => get("/member-base/page-with-member", param);
// 注销会员 || 设置耗卡密码
export const PutUpdateMemberBase = (param) => put("/member-base/update-member", param);
// 移除耗卡密码
export const PostResetMemberPassword = (param) => post("/member-base/reset_member_password", param);
//增加积分
export const addPointFlowRecord = (param) => get("/t-member-points-flow-record/addPointFlowRecord", param);

export const pointFlowRecordDetail = (param) => get("/t-member-points-flow-record/pointFlowRecordDetail", param);
export const countPointFlowRecord = (param) => get("/t-member-points-flow-record/countPointFlowRecord", param);

export const countPointBalance = () => get("/t-member-points-flow-record/countPointBalance");

export const pointDetailForMember = (param) => get("/t-member-points-flow-record/pointDetailForMember", param);

// 获取个性次卡信息
export const getPersonalityCardDate = (param) => get(`/tenant-card/${param}`);
/**
 * @description:  批量修改会员 注销 恢复
 * @param {*} param
 * @return {*}
 */
export const modifyBatchMembers = (param) => put("/member-base/batch", param);
//修改赠金
export const UpdateGiftAmount = (param) => post("/member-amount-points/update", param);
//查询赠金修改记录
export const GetGiftRecord = (param) => get("/member-amount-points/select", param);



// WEBPACK FOOTER //
// ./src/api/member.js